export const API_URL = process.env.REACT_APP_API_URL;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const OPENROUTESERVICE_API_KEY = process.env.REACT_APP_OPENROUTESERVICE_API_KEY;

export const COLOR_TO_LET = '#6abe45';
export const DEFAULT_CENTER = [50.43, 4.42];
export const DEFAULT_ZOOM = 8;
export const MIN_ZOOM = 8;
export const MAX_ZOOM = 20;
export const TOOLTIP_THRESHOLD_ZOOM = 18;